import * as bdtv_da8a6233c6aa from "@Bondit2Theme/mod-fozane";
import { LazyLoader as bdtv_412abf5d8d27 } from "@Bondit2Theme/mod-fipefi";
import { eventModal as bdtv_f6af08649f3c } from "@Bondit2Theme/mod-kodati";

class bdtv_8a37e5d827d2 extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
    this.observer = null;
    this.scrollThreshold = 300;
    this.initialized = false;
    this.isPopupOpen = false;
    this.initMobile();
  }

  connectedCallback() {
    this.addEventListener("click", this.initPopup.bind(this), false);
    this.addEventListener("keydown", this.handleKeydown.bind(this), false);
    const bdtv_bd768245ab03 = document.querySelector("bdt-naza-balao");
    this.sectionId = bdtv_bd768245ab03?.dataset.bdtFaixaVopa;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }

    if (window.Shopify && window.Shopify.designMode) {
      const bdtv_4419df5afcd6 = this;
      document.addEventListener("shopify:section:select", (bdtv_a38b388c9ad1) => {
        bdtv_4419df5afcd6.actionDesignMode(bdtv_a38b388c9ad1);
      });
      document.addEventListener("shopify:section:deselect", () => {
        bdtv_4419df5afcd6.closePopup();
      });
    }
  }

  actionDesignMode(bdtv_ceafa1798291) {
    const bdtv_a4a8eb1ac5ea = this;
    const bdtv_f485d12a2321 = bdtv_ceafa1798291.target;
    if (
      JSON.parse(bdtv_f485d12a2321.dataset.shopifyEditorSection).id ===
      this.sectionId
    ) {
      bdtv_a4a8eb1ac5ea.initPopup();
    } else {
      bdtv_a4a8eb1ac5ea.closePopup();
    }
  }

  initPopup() {
    const bdtv_5f2cebb4f2af = document.querySelector("bdt-naza-balao");
    if (window.Shopify && window.Shopify.designMode) {
      bdtv_f6af08649f3c(bdtv_5f2cebb4f2af, "close", false);
    }
    bdtv_f6af08649f3c(bdtv_5f2cebb4f2af, "open", false);
    document.documentElement.classList.add("open-modal-offer-popup");
    bdtv_da8a6233c6aa.global.rootToFocus = this;
  }

  closePopup() {
    const bdtv_aca4201868f6 = document.querySelector("bdt-naza-balao");
    bdtv_f6af08649f3c(bdtv_aca4201868f6, "close", false);
    this.isPopupOpen = false;
  }

  initMobile() {
    const bdtv_ff6ec366abc8 = window.matchMedia("(max-width: 767.98px)");
    const bdtv_09ea72d7196e = this;

    let bdtv_81668a3bb5ae = null;

    const bdtv_48fb6eee0703 = () => {
      if (bdtv_ff6ec366abc8.matches) {
        const bdtv_ebcd63e6b799 = document.querySelector("bdt-portatil-roteiro-faixa2"
        );
        if (
          bdtv_ebcd63e6b799 &&
          bdtv_ebcd63e6b799.classList.contains("bdt-dise")
        ) {
          bdtv_09ea72d7196e.mobileAppend();
        }
      }
    };

    const bdtv_0d7b6f81eb57 = () => {
      clearTimeout(bdtv_81668a3bb5ae);
      bdtv_81668a3bb5ae = setTimeout(bdtv_48fb6eee0703, 300);
    };

    bdtv_48fb6eee0703();
    bdtv_ff6ec366abc8.addEventListener("change", bdtv_48fb6eee0703);

    const bdtv_6b11fa23a23d = new MutationObserver((bdtv_cd7d6a29d038) => {
      let bdtv_92e46d193397 = false;

      bdtv_cd7d6a29d038.forEach((bdtv_0feaf33065a2) => {
        if (
          bdtv_0feaf33065a2.type === "attributes" &&
          bdtv_0feaf33065a2.attributeName === "class"
        ) {
          bdtv_92e46d193397 = true;
        }
        if (bdtv_0feaf33065a2.type === "childList") {
          bdtv_92e46d193397 = true;
        }
      });

      if (bdtv_92e46d193397) {
        bdtv_0d7b6f81eb57();
      }
    });

    bdtv_6b11fa23a23d.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });

    if (typeof Shopify !== "undefined" && Shopify.designMode) {
      [
        "shopify:section:load",
        "shopify:section:reorder",
        "shopify:section:unload",
      ].forEach((bdtv_f8dfa46d36d9) => {
        document.addEventListener(bdtv_f8dfa46d36d9, bdtv_0d7b6f81eb57);
      });
    }
  }

  mobileAppend() {
    const bdtv_02e219649f5e = document.querySelector("bdt-portatil-roteiro-faixa2");

    if (!bdtv_02e219649f5e) {
      return;
    }
    const bdtv_ac9cfeb662c3 = bdtv_02e219649f5e.querySelector(".bdt-portatil-roteiro-faixa2__corpo"
    );
    const bdtv_1d37dfbfa209 =
      bdtv_ac9cfeb662c3.querySelector(".offer-mobile");
    if (bdtv_1d37dfbfa209) {
      return;
    }
    const bdtv_fc6fd48109c5 = document.createElement("li");
    bdtv_fc6fd48109c5.classList.add("bdt-fi-1", "offer-mobile");
    bdtv_fc6fd48109c5.innerHTML = `
      <div class="bdt-nebe bdt-kozo bdt-mivo-fi bdt-coluna bdt-corpo-centro2 bdt-cabeca-tom bdt-vao-3">
<svg width="20" height="20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.326 12.217 2.059 10.95a1.338 1.338 0 0 1 0-1.883L3.326 7.8c.217-.216.392-.641.392-.941V5.067c0-.733.6-1.333 1.333-1.333h1.792c.3 0 .725-.175.941-.392l1.267-1.267a1.338 1.338 0 0 1 1.883 0l1.267 1.267c.217.217.642.392.942.392h1.791c.734 0 1.334.6 1.334 1.333V6.86c0 .3.175.725.391.941l1.267 1.267a1.338 1.338 0 0 1 0 1.883l-1.267 1.267c-.216.217-.391.642-.391.942v1.791c0 .734-.6 1.334-1.334 1.334h-1.791c-.3 0-.725.175-.942.392l-1.267 1.266a1.338 1.338 0 0 1-1.883 0l-1.267-1.267a1.537 1.537 0 0 0-.941-.391H5.05c-.733 0-1.333-.6-1.333-1.334V13.16c0-.309-.175-.734-.392-.942ZM7.5 12.5l5-5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.08 12.083h.008M7.912 7.917h.008"/></svg>
        ${window.content.offer.title}
      </div>
    `;
    const bdtv_fb1f45ae0d83 = bdtv_ac9cfeb662c3.lastElementChild;
    if (bdtv_fb1f45ae0d83) {
      bdtv_ac9cfeb662c3.insertBefore(bdtv_fc6fd48109c5, bdtv_fb1f45ae0d83);
    } else {
      bdtv_ac9cfeb662c3.appendChild(bdtv_fc6fd48109c5);
    }
    bdtv_fc6fd48109c5.addEventListener("click", this.initPopup.bind(this), false);
  }

  handleKeydown(bdtv_f08ebaddff0e) {
    if (bdtv_f08ebaddff0e.key === "Enter") {
      bdtv_f08ebaddff0e.preventDefault();
      this.initPopup();
    }
  }

  initialize() {
    if (this.initialized) return;
    this.initialized = true;
    document.addEventListener(
      "modal:opened",
      this.handleModalOpened.bind(this)
    );
  }

  handleModalOpened() {
    if (this.tagName === "SCROLL-OFFER") {
      new bdtv_412abf5d8d27(".bdt-figura-zora-no");
    }
  }
}

customElements.define("bdt-rolagem2-naza", bdtv_8a37e5d827d2);
